/* bunion-buy-2 (templates/page.bunion-buy-2.json): the cart drawer, the pack box and the page's sticky button.
   Loaded only by layout/theme.bunion-buy-2.liquid, after the drawer markup (snippets/bn2-cart-drawer.liquid).

   Contracts with code outside this file:
   - window.fhOpenCart(): the header's cart icon ([data-fh-cart] in sections/custom-header.liquid) calls it.
   - #fhCartDrawer.is-open and body.fhcd-open while the drawer is open. The sign-up popup
     (snippets/st-bunion-popup.liquid) stays shut while it is, and the Clarity tags read the body class.
   - #bnb and #bnb-add: the popup's "להזמנה עכשיו" scrolls to #bnb-add; a tap in #bnb keeps the popup away.
   - sessionStorage bnb_added (after an add) and bno_checkout (on the way to checkout): the popup reads both.
   - .fhh__count in the header shows the cart's item count. */
(function () {
  'use strict';
  var d = document, w = window;
  var ROOT = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
  var CFG = {};
  try { CFG = JSON.parse((d.getElementById('bn2-data') || {}).textContent || '{}'); } catch (e) {}
  var PID = Number(CFG.pid) || 0, PROT = CFG.prot || null, PACKS = CFG.packs || [];
  var unitsOf = {}, priceOf = {}, singlePrice = 0;
  PACKS.forEach(function (p) { unitsOf[p.id] = p.units; priceOf[p.id] = p.price; if (p.units === 1) singlePrice = p.price; });
  function packBy(units) { for (var i = 0; i < PACKS.length; i++) { if (PACKS[i].units === units) return PACKS[i]; } return null; }

  function reduced() { return !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function money(c) {
    var s = (Math.round(Number(c) || 0) / 100).toFixed(2).replace(/\.00$/, '');
    return '₪' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function packName(u) { return u === 1 ? 'מיישר אחד' : u === 2 ? 'זוג מיישרים' : u + ' מיישרים'; }

  /* One cart request. A rejected request carries Shopify's own sentence (bn2Msg), never "Failed to fetch". */
  function api(path, body) {
    var opt = body
      ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }
      : { headers: { Accept: 'application/json' } };
    return fetch(ROOT + path, opt).then(function (r) {
      if (r.ok) return r.json();
      return r.json().catch(function () { return null; }).then(function (b) {
        var err = new Error(path + ' ' + r.status); err.bn2Msg = (b && b.description) || ''; throw err;
      });
    });
  }
  function getCart() { return api('cart.js'); }

  /* The checkout prints line properties without a leading "_" under the product, and ignores compare-at prices.
     This is how the pair's saving reaches the checkout without changing any price. */
  function packProps(vid) {
    var u = unitsOf[vid] || 0, save = u * singlePrice - (priceOf[vid] || 0);
    if (u < 2 || !singlePrice || save <= 0) return null;
    return { 'המבצע': 'חוסכים ' + money(save) + (u === 2 ? ' על הזוג' : '') + ' - כבר כלול במחיר' };
  }
  function addItem(vid) {
    var item = { id: vid, quantity: 1 }, pr = packProps(vid);
    if (pr) item.properties = pr;
    return api('cart/add.js', { items: [item] });
  }

  /* =====================================================================================
     Cart drawer
     ===================================================================================== */
  var dr = d.getElementById('fhCartDrawer');
  var cart = null;
  if (dr) {
    var panel = dr.querySelector('.bn2cd__panel'),
        mainEl = dr.querySelector('[data-bn2cd-main]'),
        emptyEl = dr.querySelector('[data-bn2cd-empty]'),
        itemsEl = dr.querySelector('[data-bn2cd-items]'),
        upgEl = dr.querySelector('[data-bn2cd-upg]'),
        protEl = dr.querySelector('[data-bn2cd-prot]'),
        rowsEl = dr.querySelector('[data-bn2cd-rows]'),
        countEl = dr.querySelector('[data-bn2cd-count]'),
        coBtn = dr.querySelector('[data-bn2cd-co]'),
        closeBtn = dr.querySelector('.bn2cd__x');
    var lastFocus = null, mutating = false, syncing = false, again = false;

    var render = function (c) {
      cart = c;
      dr.classList.add('is-ready');
      d.querySelectorAll('.fhh__count').forEach(function (el) {
        el.textContent = c.item_count;
        if (c.item_count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
      });
      var lines = [], protLine = null;
      c.items.forEach(function (it) { if (PROT && it.variant_id === PROT.id) protLine = it; else lines.push(it); });

      if (!lines.length) {
        /* protection on its own is an orphan: it only makes sense next to a product */
        if (protLine && !mutating) { mutating = true; api('cart/change.js', { id: protLine.key, quantity: 0 }).then(function (nc) { mutating = false; render(nc); }).catch(function () { mutating = false; }); }
        mainEl.setAttribute('hidden', ''); emptyEl.removeAttribute('hidden'); countEl.textContent = '';
        return;
      }
      emptyEl.setAttribute('hidden', ''); mainEl.removeAttribute('hidden');

      var html = '', units = 0, bundleSave = 0, single = null, bigger = false;
      lines.forEach(function (it) {
        var mine = it.product_id === PID, u = mine ? (unitsOf[it.variant_id] || 1) : 0;
        var ref = mine ? u * singlePrice * it.quantity : 0;
        var save = ref > it.original_line_price ? ref - it.original_line_price : 0;
        if (mine) { units += u * it.quantity; bundleSave += save; if (u === 1) { if (!single) single = it; } else bigger = true; }
        var name = mine ? packName(u) : it.product_title;
        var sub = mine ? 'מיישר הבוהן של סטלורה' : (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '');
        var img = it.image ? it.image + (it.image.indexOf('?') === -1 ? '?' : '&') + 'width=200' : '';
        html += '<div class="bn2cd__item">'
          + '<div class="bn2cd__img">' + (img ? '<img src="' + esc(img) + '" alt="" width="72" height="72" loading="lazy">' : '')
          + (it.quantity > 1 ? '<span class="bn2cd__qty">×' + it.quantity + '</span>' : '') + '</div>'
          + '<div class="bn2cd__mid"><div class="bn2cd__name">' + esc(name) + '</div>'
          + (sub ? '<div class="bn2cd__sub">' + esc(sub) + '</div>' : '')
          + (save ? '<span class="bn2cd__chip">חוסכים ' + money(save) + '</span>' : '')
          + '<button type="button" class="bn2cd__rm" data-bn2cd-rm="' + esc(it.key) + '">הסרה</button></div>'
          + '<div class="bn2cd__price"><span class="bn2cd__now">' + money(it.final_line_price) + '</span>'
          + (save ? '<span class="bn2cd__was">' + money(ref) + '</span>' : '') + '</div>'
          + '</div>';
      });
      itemsEl.innerHTML = html;
      countEl.textContent = units ? '(' + (units === 1 ? 'מיישר אחד' : units + ' מיישרים') + ')' : '';

      /* One step up, a single to the pair: shown while the cart holds exactly one single and nothing bigger. */
      var pair = packBy(2);
      if (single && single.quantity === 1 && !bigger && pair && singlePrice) {
        upgEl.innerHTML = '<div class="bn2cd__upg"><div class="bn2cd__upg-m">'
          + '<div class="bn2cd__upg-t">עוד ' + money(pair.price - singlePrice) + ' ומקבלים מיישר גם לרגל השנייה</div>'
          + '<div class="bn2cd__upg-s">זוג ב-' + money(pair.price) + ' במקום ' + money(2 * singlePrice) + '</div>'
          + '<div class="bn2cd__upg-s">רוב הלקוחות בוחרים זוג</div></div>'
          + '<button type="button" class="bn2cd__upg-btn" data-bn2cd-upg="' + esc(single.key) + '">'
          + '<span class="bn2cd__upg-idle">שדרוג לזוג</span><span class="bn2cd__upg-busy" aria-hidden="true"><span class="bn2-spin bn2-spin--navy"></span></span>'
          + '</button></div>';
      } else upgEl.innerHTML = '';

      protEl.innerHTML = PROT ? '<div class="bn2cd__prot">'
        + '<svg aria-hidden="true" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z"/><path d="M9 12l2 2 4-4" stroke-linecap="round"/></svg>'
        + '<div class="bn2cd__prot-m"><div class="bn2cd__prot-t">הגנת משלוח · ' + money(PROT.price) + '</div>'
        + '<div class="bn2cd__prot-s">כיסוי לאובדן, גניבה ונזק במשלוח</div></div>'
        + '<button type="button" class="bn2cd__sw" role="switch" aria-checked="' + (protLine ? 'true' : 'false') + '" aria-label="הגנת משלוח ב-' + money(PROT.price) + '" data-bn2cd-protsw></button>'
        + '</div>' : '';

      /* Totals. total_discount covers codes and automatic discounts; the pack saving is ours, against singles. */
      var codeOff = c.total_discount || 0, total = c.total_price, was = total + bundleSave + codeOff;
      var codes = (c.discount_codes || []).filter(function (x) { return x && x.applicable; }).map(function (x) { return x.code; });
      var rows = '';
      if (bundleSave) rows += '<div class="bn2cd__row bn2cd__row--save"><span>חוסכים בחבילה</span><span dir="ltr">−' + money(bundleSave) + '</span></div>';
      if (codeOff) rows += '<div class="bn2cd__row bn2cd__row--save"><span>' + esc(codes.length ? 'קוד ' + codes.join(', ') : 'הנחה') + '</span><span dir="ltr">−' + money(codeOff) + '</span></div>';
      rows += '<div class="bn2cd__row bn2cd__row--free"><span>משלוח</span><span>חינם</span></div>';
      rows += '<div class="bn2cd__row bn2cd__row--total"><span>סה״כ לתשלום</span><span dir="ltr">' + (was > total ? '<s>' + money(was) + '</s>' : '') + '<b>' + money(total) + '</b></span></div>';
      /* The popup's code is saved through Shopify's discount link. If the cart does not show it yet, say where it applies. */
      var pend = sget('stp_code');
      if (pend && !codeOff && codes.indexOf(pend) === -1) rows += '<p class="bn2cd__note">הקוד ' + esc(pend) + ' יופעל בעמוד התשלום</p>';
      rowsEl.innerHTML = rows;
    };

    var refresh = function () {
      if (syncing) { again = true; return Promise.resolve(cart); }
      syncing = true;
      return getCart().then(render).catch(function () {}).then(function () {
        syncing = false;
        if (again) { again = false; return refresh(); }
        return cart;
      });
    };

    var trap = function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = [].slice.call(panel.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    var open = function (fresh) {
      if (dr.classList.contains('is-open')) { if (!fresh) refresh(); return; }
      lastFocus = d.activeElement;
      if (cart) render(cart);
      dr.classList.add('is-open'); dr.setAttribute('aria-hidden', 'false'); d.body.classList.add('fhcd-open');
      d.addEventListener('keydown', trap);
      setTimeout(function () { try { closeBtn.focus({ preventScroll: true }); } catch (e) {} }, 50);
      if (!fresh) refresh();
    };
    var close = function () {
      if (!dr.classList.contains('is-open')) return;
      dr.classList.remove('is-open'); dr.setAttribute('aria-hidden', 'true'); d.body.classList.remove('fhcd-open');
      d.removeEventListener('keydown', trap);
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    };

    /* Puts exactly one of the chosen pack in the cart. Other bunion lines go: a shopper who adds the pair after the
       single meant to switch, not to buy three (the control's box stacks them). Other products stay. */
    var addPack = function (vid) {
      return getCart().then(function (c) {
        var upd = {}, has = false;
        c.items.forEach(function (it) {
          if (it.product_id !== PID) return;
          if (!has && it.variant_id === vid) { has = true; if (it.quantity !== 1) upd[it.key] = 1; }
          else upd[it.key] = 0;
        });
        var step = Object.keys(upd).length ? api('cart/update.js', { updates: upd }) : Promise.resolve();
        return step.then(function () { return has ? null : addItem(vid); });
      }).then(getCart).then(function (c) { render(c); return c; });
    };

    var busyBtn = function (b, on) {
      if (!b) return;
      b.classList.toggle('is-busy', on);
      if (b.tagName === 'BUTTON') b.disabled = on;
      b.setAttribute('aria-busy', on ? 'true' : 'false');
    };

    dr.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-bn2cd-close]')) { close(); return; }
      if (t.closest('[data-bn2cd-back]')) {
        close();
        var b = d.getElementById('bnb');
        if (b && w.bn2ToBox) setTimeout(w.bn2ToBox, 120);
        else if (b) setTimeout(function () { b.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' }); }, 120);
        else location.href = ROOT + 'pages/bunion-buy';
        return;
      }
      var rm = t.closest('[data-bn2cd-rm]');
      if (rm && !mutating) {
        mutating = true; rm.disabled = true;
        api('cart/change.js', { id: rm.getAttribute('data-bn2cd-rm'), quantity: 0 })
          .then(function (nc) { mutating = false; render(nc); })
          .catch(function () { mutating = false; rm.disabled = false; refresh(); });
        return;
      }
      var up = t.closest('[data-bn2cd-upg]');
      if (up && !mutating) {
        var pair = packBy(2); if (!pair) return;
        mutating = true; busyBtn(up, true);
        addItem(pair.id)
          .then(function () { return api('cart/change.js', { id: up.getAttribute('data-bn2cd-upg'), quantity: 0 }); })
          .then(function (nc) { mutating = false; render(nc); })
          .catch(function () { mutating = false; busyBtn(up, false); refresh(); });
        return;
      }
      var sw = t.closest('[data-bn2cd-protsw]');
      if (sw && !mutating && PROT && cart) {
        var line = null;
        cart.items.forEach(function (it) { if (it.variant_id === PROT.id) line = it; });
        mutating = true; sw.setAttribute('aria-checked', line ? 'false' : 'true');
        (line ? api('cart/change.js', { id: line.key, quantity: 0 }) : api('cart/add.js', { items: [{ id: PROT.id, quantity: 1 }] }).then(getCart))
          .then(function (nc) { mutating = false; render(nc); })
          .catch(function () { mutating = false; sw.setAttribute('aria-checked', line ? 'true' : 'false'); refresh(); });
        return;
      }
      if (t.closest('[data-bn2cd-co]')) {
        if (coBtn.classList.contains('is-busy')) { e.preventDefault(); return; }
        busyBtn(coBtn, true); sset('bno_checkout', '1');
      }
    });

    /* Back from the checkout with the back button: the page comes from the back-forward cache, buttons still busy. */
    w.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      busyBtn(coBtn, false); mutating = false;
      refresh();
    });

    w.fhOpenCart = function () { open(false); };
    w.bn2Cart = { open: open, close: close, refresh: refresh, addPack: addPack };
    refresh();
  }

  /* =====================================================================================
     Pack box, its place on the page, and the page's sticky button
     ===================================================================================== */
  var box = d.getElementById('bnb');
  if (!box || !w.bn2Cart) return;
  var group = box.querySelector('[data-bn2-tiers]'),
      tiers = [].slice.call(box.querySelectorAll('.bn2-tier')),
      atc = d.getElementById('bnb-add'),
      offerEl = box.querySelector('[data-bn2-offer]'),
      errEl = box.querySelector('[data-bn2-err]');
  if (!tiers.length || !atc) return;
  var sel = 0, busy = false, wd = null;
  tiers.forEach(function (t, i) { if (t.getAttribute('aria-checked') === 'true') sel = i; });

  function shown(el) { return !!(el && el.getClientRects().length); }

  /* The box's place. The sales bodies carry the offer block twice, one copy for phones (body 2) and one for wider
     screens (body 3), each with a "לחשיפת המבצע שלכם" button marked [data-bn2-spot]. An id can exist once, so the
     section renders the box once, between the two copies, and this moves it in front of the button in whichever copy
     is on screen, and hides that button. It runs at start-up, thousands of pixels below the first screen, so nothing
     the shopper sees moves. A spot counts as on screen when its parent is: the spot itself is hidden once used. */
  var spots = [].slice.call(d.querySelectorAll('[data-bn2-spot]')), spotNow = null;
  function place() {
    var s = null;
    spots.forEach(function (x) { if (!s && shown(x.parentElement)) s = x; });
    if (!s || s === spotNow) return;
    if (spotNow) spotNow.hidden = false;
    s.parentNode.insertBefore(box, s);
    s.hidden = true;
    spotNow = s;
  }
  place();

  function applySel() {
    tiers.forEach(function (t, i) { var on = i === sel; t.setAttribute('aria-checked', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
    var name = tiers[sel].getAttribute('data-name');
    if (offerEl) offerEl.textContent = name;
    atc.setAttribute('aria-label', 'הוספה לסל: ' + name + ', 90 ימי ניסיון');
  }
  function showErr(msg) { if (errEl) errEl.textContent = (msg && String(msg).trim()) || 'משהו השתבש בהוספה לסל. נסו שוב.'; }
  function hideErr() { if (errEl) errEl.textContent = ''; }
  function pick(i, focus) {
    if (busy || i < 0 || i >= tiers.length) return;
    sel = i; hideErr(); applySel();
    if (focus) tiers[i].focus();
  }
  group.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.bn2-tier') : null;
    if (t) pick(tiers.indexOf(t), false);
  });
  group.addEventListener('keydown', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.bn2-tier') : null;
    if (!t || busy) return;
    var i = tiers.indexOf(t), n = tiers.length, k = e.key, next = -1;
    if (k === ' ' || k === 'Spacebar' || k === 'Enter') { e.preventDefault(); pick(i, true); return; }
    /* stacked list in RTL: down and left both mean the next card */
    if (k === 'ArrowDown' || k === 'ArrowLeft') next = (i + 1) % n;
    else if (k === 'ArrowUp' || k === 'ArrowRight') next = (i - 1 + n) % n;
    else if (k === 'Home') next = 0;
    else if (k === 'End') next = n - 1;
    if (next >= 0) { e.preventDefault(); pick(next, true); }
  });

  function setBusy(on) {
    busy = on;
    atc.classList.toggle('is-busy', on); atc.disabled = on; atc.setAttribute('aria-busy', on ? 'true' : 'false');
    if (on) group.setAttribute('aria-disabled', 'true'); else group.removeAttribute('aria-disabled');
  }
  atc.addEventListener('click', function () {
    if (busy) return;
    var vid = Number(tiers[sel].getAttribute('data-variant'));
    if (!vid) { showErr(); return; }
    hideErr(); setBusy(true);
    /* a request that never settles must not leave the only buy button dead */
    clearTimeout(wd); wd = setTimeout(function () { setBusy(false); }, 15000);
    w.bn2Cart.addPack(vid).then(function () {
      sset('bnb_added', '1');
      /* Version 4 (data-bn-direct, sections/bn-buy-2.liquid): straight to the checkout, no drawer. The button stays
         busy while the checkout loads; pageshow below frees it if she comes back with the back button. */
      if (d.querySelector('[data-bn-direct]')) { sset('bno_checkout', '1'); location.href = ROOT + 'checkout'; return; }
      clearTimeout(wd); setBusy(false);
      w.bn2Cart.open(true);
    }).catch(function (err) {
      clearTimeout(wd); setBusy(false);
      showErr(err && err.bn2Msg);
    });
  });

  function pulse() {
    if (reduced()) return;
    box.classList.remove('is-pulse'); void box.offsetWidth; box.classList.add('is-pulse');
    setTimeout(function () { box.classList.remove('is-pulse'); }, 1200);
  }
  function scrollToBox() { box.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' }); }

  /* A smooth scroll aims at where the box is when it starts, and the box is thousands of pixels away. Anything that
     changes height on the way moves the target (bn2.css reserves the pictures' boxes; this is the backstop). So once
     the page has stopped scrolling, look: if the add button is not on screen, go again (at most 3 times), and ring the
     box when it arrives. The first touch, wheel or key from the shopper ends it, so it never fights her own scroll. */
  var settleT = 0, settleStop = null;
  function settle() {
    if (settleStop) settleStop();
    var lastY = -1, still = 0, ticks = 0, again = 3;
    var stop = function () {
      clearTimeout(settleT); settleStop = null;
      ['touchstart', 'wheel', 'keydown'].forEach(function (k) { w.removeEventListener(k, stop, true); });
    };
    settleStop = stop;
    ['touchstart', 'wheel', 'keydown'].forEach(function (k) { w.addEventListener(k, stop, true); });
    (function tick() {
      var y = w.pageYOffset;
      still = y === lastY ? still + 1 : 0; lastY = y;
      if (still >= 2) {
        var r = atc.getBoundingClientRect();
        if (r.top >= 0 && r.bottom <= w.innerHeight) { stop(); pulse(); return; }
        if (again-- <= 0) { stop(); return; }
        scrollToBox(); still = 0;
      }
      if (++ticks > 80) { stop(); return; }
      settleT = setTimeout(tick, 100);
    })();
  }
  function toBox() { scrollToBox(); settle(); }
  w.bn2ToBox = toBox;
  /* Every button in the sales bodies, the first screen's picture and the sticky button link to #order: here they
     all bring the box up. */
  d.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-bn-order], a[href="#order"]') : null;
    if (!t || box.contains(t)) return;
    e.preventDefault();
    toBox();
  });
  /* Version 3 (data-bn3, sections/bn-buy-2.liquid): a tap anywhere on the sale bar on top (#360396 phone, #977297
     desktop) or on the sticky bar brings the box up, not just on their buttons. The top bar drew dead taps (Clarity
     10/3-10/7). The bars get data-bnb-jump, so the sign-up popup counts the tap as choosing and stays shut. Taps on a
     link or button are left to the handler above. */
  if (d.querySelector('[data-bn3]')) {
    var BARS = '[data-eid="360396"], [data-eid="977297"], [data-bn2-stick]';
    [].forEach.call(d.querySelectorAll(BARS), function (el) { el.setAttribute('data-bnb-jump', ''); });
    d.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t || !t.closest(BARS) || t.closest('a, button')) return;
      e.preventDefault();
      toBox();
    });
  }
  /* The sign-up popup's "להזמנה עכשיו" ([data-stp-order], assets/st-popup.js) runs its own smooth scroll to #bnb-add.
     Its click handler runs first; this one, on the document, follows and watches that scroll land. */
  d.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-stp-order]')) setTimeout(settle, 0);
  });

  /* The sticky button: the control's own bar at the end of body 3 ([data-bn2-stick], position:sticky at the bottom).
     Up once the first screen's button ([data-bn2-first], one per screen size) has scrolled off the top; down while
     the box is on screen, where it would cover the box's own button, and while the cart drawer is open. */
  var stick = d.querySelector('[data-bn2-stick]');
  var firsts = [].slice.call(d.querySelectorAll('[data-bn2-first]'));
  if (stick) {
    var above = [], boxIn = false, drawerOpen = d.body.classList.contains('fhcd-open');
    var update = function () {
      var on = above.some(Boolean) && !boxIn && !drawerOpen;
      if (stick.classList.contains('is-on') === on) return;
      stick.classList.toggle('is-on', on);
      if (on) { stick.removeAttribute('inert'); stick.removeAttribute('aria-hidden'); }
      else { stick.setAttribute('inert', ''); stick.setAttribute('aria-hidden', 'true'); }
    };
    if ('IntersectionObserver' in w && firsts.length) {
      /* the copy for the other screen size is display:none: it never intersects and its box is all zeros, so it
         never counts as scrolled past */
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          var k = firsts.indexOf(en.target);
          if (k >= 0) above[k] = !en.isIntersecting && en.boundingClientRect.bottom <= 0 && en.boundingClientRect.height > 0;
        });
        update();
      }, { threshold: 0 });
      firsts.forEach(function (el) { io.observe(el); });
      new IntersectionObserver(function (es) { boxIn = es[es.length - 1].isIntersecting; update(); }, { threshold: 0 }).observe(box);
    } else {
      above = [true]; update();
    }
    /* body.fhcd-open is the drawer's flag. Act only on a real change. */
    if ('MutationObserver' in w) {
      new MutationObserver(function () {
        var o = d.body.classList.contains('fhcd-open');
        if (o !== drawerOpen) { drawerOpen = o; update(); }
      }).observe(d.body, { attributes: true, attributeFilter: ['class'] });
    }
  }

  /* Across the 600px line (a turned tablet, a resized window) the other copy of the offer block shows: the box
     follows it. */
  var rt = 0;
  w.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(place, 150); });
  w.addEventListener('pageshow', function (e) { if (e.persisted) { clearTimeout(wd); setBusy(false); } });
  applySel();
})();
